module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Ремонт бытовой техники","short_name":"Ремонт бытовой техники","start_url":"/","background_color":"#f5f7fa","theme_color":"#f5f7fa","display":"standalone","icon":"src/images/LOGO.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"3f98dea1275a93e1f2d352c4fd5423d5"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
